import React, { useState } from "react";
import Navbar from "../../../components/navbar/navbar";
import TitleSection from "../../../components/title-section/title-section";
import Footer from "../../../components/footer/Footer";
import "./aeromexico-cargo.css";
import { useTranslation } from "react-i18next";
import ScrollToTop from "../../../components/scrollToTop/scrollToTop";
import navBarEn from "../../../translations/en/navbar.json";
import navBarEs from "../../../translations/es/navbar.json";
import Helmet from "react-helmet";
import BreadCrumb from "../../../components/breadcrumb/breadcrumb";
import imgBg from "../../../assets/imgs/about-us/bg-nosotros.png";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa6";

function AeromexicoCargo() {
  const [tAeroMexicoCargo] = useTranslation("aboutUs");
  const [tSMetaData] = useTranslation("metaData");
  const [animClass, setAnimClass] = useState("start");
  const [indexText, setIndexText] = useState(0);

  sessionStorage.setItem(
    "routeEs",
    `/${navBarEs["category-services"]["about-us"]}/${
      Object.keys(navBarEs["about-us"])[0]
    }`
  );

  sessionStorage.setItem(
    "routeEn",
    `/${navBarEn["category-services"]["about-us"]}/${
      Object.keys(navBarEn["about-us"])[0]
    }`
  );

  const textInformatio = [
    {
      year: 2020,
      title_img: "Modelo Chárter COVID-19",
      subtitle_img:
        "Instrumentación del modelo de vuelos chárter para mantener activa la operación de carga durante la pandemia.",
      title_text: "2020 - Instrumentación del Modelo de Vuelos Chárter (COVID-19)",
      texts: {
        li: [
          "Se realizaron 425 vuelos exclusivos de carga con ingresos aproximados de 120 M usd, del 24 de marzo de 2020 a finales de mayo de 2022.",
          "Se transportaron vacunas, insumos y equipo médico a 3 continentes (América, Europa y Asia) y 22 países.",
          "Se operaron hasta 8 vuelos de manera simultánea, recorriendo 11 millones de kilómetros (equivalente a 270 vueltas al mundo).",
          "Rutas emblemáticas: Shenzhen, Shanghái, Hong Kong, Moscú y Jamaica, entre otras."
        ],
        paragraph: {
          p1: "Este periodo demostró la capacidad de respuesta de AM Cargo ante escenarios de alta complejidad operativa.",
          p2: ""
        }
      }
    },
    {
      year: 2021,
      title_img: "Nuevos Negocios y Pharma",
      subtitle_img:
        "Aceleración comercial con e-commerce doméstico y certificación internacional del segmento farmacéutico.",
      title_text: "2021 - e-commerce doméstico y Certificación IATA CEIV Pharma",
      texts: {
        li: [
          "En noviembre de 2021 se incorpora Amazon como cliente, iniciando operaciones en la ruta MTY-MID.",
          "Al cierre de 2021 se transportaron 3 mil kilos en dicha ruta; posteriormente la red crece a 12 rutas y 350 toneladas promedio mensuales.",
          "Se obtiene la certificación IATA CEIV Pharma por cumplimiento de los más altos estándares de procesos e instalaciones para manejo farmacéutico.",
          "El posicionamiento de pharma consolida crecimiento de +57% en 2024 vs 2021."
        ],
        paragraph: {
          p1: "Con estos hitos se fortaleció el portafolio de alto valor y se amplió la base comercial del negocio.",
          p2: ""
        }
      }
    },
    {
      year: 2022,
      title_img: "Seguridad y Control",
      subtitle_img:
        "Renovación de infraestructura crítica para robustecer trazabilidad y soporte operativo en terminal doméstica.",
      title_text: "2022 - Renovación del CCTV en Terminal de Carga Doméstica",
      texts: {
        li: [
          "Se moderniza el CCTV con más de 100 cámaras de video y tecnología reciente.",
          "Se mejora la calidad de imagen y el respaldo de información para dar mayor soporte a las etapas del flujo y traslado de carga."
        ],
        paragraph: {
          p1: "La actualización incrementó visibilidad operativa y capacidad de seguimiento en procesos críticos.",
          p2: ""
        }
      }
    },
    {
      year: 2023,
      title_img: "Skypallet y Terminal",
      subtitle_img:
        "Eficiencia operativa en exportación MEX e inicio de modernización de terminal doméstica.",
      title_text: "2023 - Implementación de SkyPallet y remodelación de terminal doméstica",
      texts: {
        li: [
          "Se implementa SkyPallet en exportación MEX para optimizar armado de pallets y aprovechamiento de capacidad por vuelo.",
          "Arranca el proyecto de remodelación de la terminal doméstica inaugurada en 2011.",
          "Se duplican andenes de carga/descarga para mejorar tiempos de atención y flujos de entrada y salida.",
          "Se incrementa la eficiencia en recepción, inspección y preparación de carga."
        ],
        paragraph: {
          p1: "Estas acciones prepararon la operación para escalar volumen con mayor productividad.",
          p2: ""
        }
      }
    },
    {
      year: 2024,
      title_img: "Expansión, Certificación y Eficiencia",
      subtitle_img:
        "Año de expansión internacional, renovación de certificaciones y consolidación operativa/comercial.",
      title_text: "2024 - Acontecimientos relevantes por mes y por eje",
      texts: {
        li: [
          "Enero: lanzamiento del primer video corporativo de AM Cargo para posicionamiento de marca en canales digitales, aviones y eventos.",
          "Abril y octubre: apertura de estaciones internacionales en Houston y Seattle; agosto: reapertura de Incheon (Asia).",
          "Octubre: campaña de visibilidad de la alianza Amazon-Aeroméxico; el cliente supera 600 toneladas promedio mensuales a 15 destinos.",
          "Noviembre: reinauguración de la Terminal de Carga Doméstica T2 AICM (+500 m2 en aceptación y +30% de capacidad de almacenaje).",
          "Noviembre: recertificación CEIV Pharma de IATA bajo liderazgo de AM Cargo y coordinación con GAM.",
          "Noviembre: AM Cargo fue anfitrión del evento SkyTeam Cargo 2024 en Ciudad de México.",
          "Se implementa proyecto Watch para registro de guías y piezas en MEX, MTY, TIJ, GDL, MID, CUN, HMO, MXL y CUL.",
          "Se incorporan GRU y LAX a SkyPallet para optimizar espacios de carga en vuelos de cabina ancha.",
          "Infraestructura: cámaras frías en LAP, MXL, MZT, OAX y VER; aumento de estaciones con rayos X de 5 (2023) a 10 (2024).",
          "Revenue Management: inicia assessment con RTS para mejorar pricing y gestión de capacidades."
        ],
        paragraph: {
          p1: "En 2024 también se fortalecieron iniciativas de marketing, procesos operativos y experiencia de colaboradores en terminales.",
          p2: "El producto pharma representó 8% de los ingresos totales de AM Cargo durante 2024."
        }
      }
    },
    {
      year: 2025,
      title_img: "Resultados Históricos",
      subtitle_img:
        "Consolidación del mejor desempeño en la historia de AM Cargo, con expansión internacional y ejecución de alto impacto.",
      title_text: "2025 - Crecimiento récord, tecnología, infraestructura y negocio",
      texts: {
        li: [
          "Se alcanzan 170 mil toneladas y 292 M usd en ingresos comerciales (+4% volumen y +2% ingresos YoY; +20% y +52% vs 2019 sin cargueros).",
          "Expansión internacional: febrero Newark, octubre Las Vegas y noviembre Cali.",
          "Septiembre: inicio de operaciones con AAACESA en recinto fiscal AICM para ampliar capacidad operativa (TME y almacén fiscal).",
          "Diciembre: arranque de Punto Cargo en MTY y BJX junto con Tiendas de Viaje para acercar servicio a centros urbanos.",
          "Manejo de materiales radioactivos: operación desde agosto en AMS y CDG; continúa actualización para elevar índice permitido.",
          "SkyPallet se amplía con MAD y LHR (sumándose a LAX y GRU).",
          "Escaneo a pie de avión: implementación total en vuelos domésticos saliendo de MEX e inicio de despliegue en internacionales.",
          "Tecnología: desarrollo de ChatBot para WhatsApp, automatización KPI FAB, control de efectivo con robot CPM y robot de inventarios.",
          "Curso e-learning para GSAs enfocado en responsabilidades del proceso lead to cash.",
          "Infraestructura: rayos X en MZT, REX y LMM (13 estaciones en total), ETD en CUU/TAM/LAP/VSA/TRC/VER y aprobación de CCTV para 17 estaciones."
        ],
        paragraph: {
          p1: "Durante 2025 se incorporaron además contenedores refrigerados y montacargas con báscula para reforzar control de temperatura y recepción.",
          p2: "Las mejoras técnicas y comerciales preparan la base para crecimiento adicional de ingresos en rutas top de exportación."
        }
      }
    },
    /* Temporalmente oculto: sección 2026 en desarrollo
    {
      year: 2026,
      title_img: "Despliegue y Escalamiento",
      subtitle_img:
        "Continuidad de iniciativas estratégicas para crecimiento rentable y mayor cobertura operativa.",
      title_text: "2026 - Ejecución de siguientes fases",
      texts: {
        li: [
          "Revenue Management (Velocity): habilitación de capa de datos, infraestructura y plataforma para implementación de Inventory Management & Better Pricing.",
          "SkyPallet: plan de incorporación de NRT, CDG y JFK.",
          "Cámaras frías: instalación de equipos pharma en TIJ y GDL, y perecederos en LMM y GDL.",
          "Continuidad del despliegue tecnológico en atención al cliente y canales digitales."
        ],
        paragraph: {
          p1: "El objetivo 2026 es capitalizar capacidades construidas en 2024-2025 para sostener crecimiento y elevar niveles de servicio.",
          p2: ""
        }
      }
    }
    */
  ];

  const changeInfo = (type, index) => {
    setAnimClass("end");

    setTimeout(() => {
      if(type === "minus") {
        setIndexText((prevIndex) => (prevIndex + 1) % textInformatio.length);
      } else if(type === "plus") {
        setIndexText((prevIndex) => (prevIndex - 1 + textInformatio.length) % textInformatio.length);
      } else if(type === "custom") {
        setIndexText(index);
      }
      setAnimClass("start");
    }, 1000);
  }

  const pinkStatusPoint = (index) => {
    if(index <= indexText) {
      return "pink";
    }
    return "";
  }

  const pinkStatusLine = () => {
    const mediumValue = parseFloat(((indexText + 1) + (indexText + 2)) / 2);
    const minValue = 1;
    const maxValue = textInformatio.length;

    let finalPercent = ((mediumValue - minValue) / (maxValue - minValue)) * 100;

    if(finalPercent > 100) {
      finalPercent = 100
    }
    return `${finalPercent}%`
  }

  return (
    <>
      <Helmet>
        <title>{tSMetaData("nosotros.title")}</title>
        <meta name="description" content={tSMetaData("nosotros.description")} />
      </Helmet>
      <ScrollToTop />
      <Navbar />
      <BreadCrumb />
      <TitleSection
        title={tAeroMexicoCargo("title.title-page")}
        headingLevel={1}
      />
      
      
      <div className="our-container-img">
        <div className="bg-opacity"></div>
        <img src={imgBg} alt="Aeromexico Cargo" />
        <button className="arrow-left arrow" onClick={() => changeInfo("plus")}><FaAngleLeft /></button>
        <button className="arrow-right arrow" onClick={() => changeInfo("minus")}><FaAngleRight /></button>

        <div className="info-text">
          <h3 className={`tit_anim_1 ${animClass}`}>{textInformatio[indexText].year}</h3>
          <h5 className={`sbt_anim_1 ${animClass}`}>{textInformatio[indexText].title_img}</h5>
          <p className={`txt_anim_1 ${animClass}`}>{textInformatio[indexText].subtitle_img}</p>
        </div>

        <div className="checkpoint-content">
          <div className="checkpoint">
            <div className="line-pink" style={{ width: pinkStatusLine() }}></div>
            <div className="line"></div>

            {textInformatio.map((item, index) => (
              <div className="item-content" key={index}>
                <div className={`circle ${pinkStatusPoint(index)}`} onClick={() => changeInfo('custom', index)}></div>
                <p className="text">{item.year}</p>
              </div>
            ))}

          </div>
        </div>
      </div>

      <div className="amc-out-title">
        <h4>{textInformatio[indexText].title_text}</h4>
      </div>

      <div className="cnt-global-info-our">
        <button className="btn-height" onClick={() => changeInfo("plus")}><FaAngleLeft /></button>
        <div>
          <div className="amc-our-information">
            <p className="principal-text panel-intro">
              {textInformatio[indexText].texts.paragraph.p1}
            </p>
            <ul className="principal-text panel-list">
              {textInformatio[indexText].texts.li.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>

            {textInformatio[indexText].texts.paragraph.p2 ? (
              <p className="principal-text panel-outro">{textInformatio[indexText].texts.paragraph.p2}</p>
            ) : null}
          </div>
        </div>

        <button className="btn-height" onClick={() => changeInfo("minus")}><FaAngleRight /></button>
      </div>

      <Footer />
    </>
  );
}

export default AeromexicoCargo;
